module.exports = __webpack_public_path__ + "static/halfling-1-57abce3dbf1656d346b0aa85ea14dab6.png";